import { useJournalAnalytics } from 'app/analytics/useJournalAnalytics';

import {
  JournalCardReactions,
  useCreateJournalReplyReaction,
  useDeleteJournalReplyReaction,
  JournalReaction,
} from 'features/journal';
import { User } from 'features/user/User';

type TJournalReplyCardReactions = {
  participantId: string;
  replyId: string;
  noteId: string;
  reactions: JournalReaction[];
  user: User;
};

export const JournalReplyCardReactions = ({
  participantId,
  replyId,
  noteId,
  reactions,
  user,
}: TJournalReplyCardReactions) => {
  const { mutateAsync: addReaction } = useCreateJournalReplyReaction({
    participantId,
    user,
  });
  const { mutateAsync: removeReaction } = useDeleteJournalReplyReaction({
    participantId,
  });
  const { sendNoteReplyReactionAddedAnalyticsEvent } = useJournalAnalytics();

  const handleAddReaction = async (reaction: string) => {
    await addReaction({ noteId, replyId, reaction });

    sendNoteReplyReactionAddedAnalyticsEvent();
  };

  const handleRemoveReaction = async (reactionId: number) => {
    const isReactionTemporary = reactions.some(
      (reaction) => reaction.temporaryReactionId === reactionId
    );

    !isReactionTemporary &&
      (await removeReaction({ noteId, replyId, reactionId }));
  };

  return (
    <JournalCardReactions
      emojiPickerPosition="start"
      reactions={reactions}
      onAddReaction={(reaction: string) => handleAddReaction(reaction)}
      onRemoveReaction={(reactionId: number) =>
        handleRemoveReaction(reactionId)
      }
      user={user}
    />
  );
};
